/**
 * <s-dert-language-suggest> — shows a slim bar only when the shopper's browser language
 * matches another language published for their market. Choosing it submits the
 * localization form; dismissing it is remembered so the bar doesn't return.
 */
const STORAGE_KEY = 'dert-language-suggest-dismissed';

class SDertLanguageSuggest extends HTMLElement {
  #ac = null;

  connectedCallback() {
    this.#ac = new AbortController();
    if (this.#isDismissed()) return;

    const current = (this.dataset.current || '').toLowerCase();
    const offered = [...this.querySelectorAll('button[data-language-option]')].map((el) => el.dataset.languageOption);
    const match = this.#findMatch(offered, current);
    if (!match) return;

    for (const el of this.querySelectorAll('[data-language-option]')) {
      el.hidden = el.dataset.languageOption !== match;
    }
    this.hidden = false;

    this.querySelector('[data-language-dismiss]')?.addEventListener('click', () => {
      try { localStorage.setItem(STORAGE_KEY, '1'); } catch (e) { /* storage unavailable */ }
      this.hidden = true;
    }, { signal: this.#ac.signal });
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }

  #isDismissed() {
    try { return localStorage.getItem(STORAGE_KEY) === '1'; } catch (e) { return false; }
  }

  /** First browser language that the store offers and isn't already showing. */
  #findMatch(offered, current) {
    const wanted = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
    for (const raw of wanted) {
      if (!raw) continue;
      const tag = raw.toLowerCase();
      const base = tag.split('-')[0];
      if (tag === current || base === current.split('-')[0]) return null;
      const hit = offered.find((code) => code.toLowerCase() === tag) || offered.find((code) => code.toLowerCase().split('-')[0] === base);
      if (hit) return hit;
    }
    return null;
  }
}

if (!customElements.get('s-dert-language-suggest')) customElements.define('s-dert-language-suggest', SDertLanguageSuggest);
